<template>
  <b-container class="container-layout" fluid>
    <b-row class="mt-5" align-h="center">
      <b-col class="mt-5" lg="10">
        <p class="title-account-search">CUENTAS DE USUARIOS</p>
      </b-col>
    </b-row>
    <b-row class="mt-5" align-h="center">
      <b-col cols="10">
        <b-table-simple id="my-table" class="table-result-account" striped hover responsive>
          <b-thead class="thead-table-keys">
            <b-tr>
              <b-th class="text-center" colspan="4">Nombres y apellidos</b-th>
              <b-th class="text-center" v-if="isAdmin">Correo</b-th>

              <b-th class="text-center">DNI</b-th>

              <b-th class="text-center">ROL</b-th>
              <b-th style="width:10%" class="text-center">Restablecer cuenta</b-th>
              <b-th class="text-center">Habilitar</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="body-result-key">
            <tr v-for="(items,index) in list" :key="index" class="puntajes-module">
              <td class="nombre-key" colspan="4">{{items.name}}</td>
              <td>{{items.email}}</td>
              <td>{{items.dni}}</td>
              <td>{{items.tipo | rol}}</td>
              <td>
                <img
                  @click="UpdatePassword(items.id)"
                  style="cursor:pointer"
                  src="@/assets/images/account.png"
                  alt
                />
              </td>
              <td>
                <input
                  @change="onChange($event, items.id)"
                  type="checkbox"
                  class="checkbox-round"
                  :checked="items.active"
                />
              </td>
            </tr>
            <tr></tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          align="center"
          :total-rows="totalRows"
          v-model="currentPage"
          :per-page="perPage"
        />
      </b-col>
    </b-row>
    <b-modal content-class="modal-finish" hide-footer ref="modal-delete" centered size="md">
      <b-row align-h="center" class="mt-5 examen-finish">
        <p class="mt-2" style="color:#0F376E">Eliminar Key de acceso</p>
      </b-row>
      <b-row align-h="center" class="mt-4 examen-finish2">
        <p>Estas seguro que desea eliminar este key de acceso?</p>
      </b-row>
      <b-row align-h="center" class="mb-1 mt-4 ml-1">
        <b-col lg="6">
          <button
            @click="cancel()"
            style="color:#0F376E!important"
            class="modal-button-cancel"
          >CANCELAR</button>
        </b-col>
        <b-col lg="6">
          <button
            @click="accept()"
            style="background-color:#0F376E!important"
            class="modal-button-accept"
          >ACEPTAR</button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal content-class="modal-password" hide-footer ref="modal-password" centered size="lg">
      <b-row align-h="center">
        <b-col lg="10">
          <p class="title-account-password">RESTABLECER CUENTA</p>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-n4">
        <b-col lg="8">
          <input
            required
            placeholder="Ingrese nueva contraseña"
            class="pl-2 mt-5 account-dame"
            type="password"
            v-model="password"
          />
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col lg="8">
          <input
            required
            placeholder="Repetir nueva contraseña"
            class="pl-2 mt-4 account-dame"
            type="password"
            v-model="password2"
            id="password"
          />
        </b-col>
        <b-tooltip
          :show.sync="show2"
          :disabled.sync="show"
          target="password"
          custom-class="my-tooltip-class"
        >Las contraseñas deben coincidir</b-tooltip>
      </b-row>

      <b-row align-h="center" class="mb-4 mt-4">
        <button @click="ResPassword()" class="password-aceptar">ACEPTAR</button>
      </b-row>
    </b-modal>
    <b-modal content-class="modal-account" hide-footer ref="modal-password2" centered size="md">
      <b-row align-h="center" class="mt-2">
        <img src="@/assets/images/checkdatos.png" alt />
      </b-row>

      <b-row align-h="center" class="mt-3">
        <b-col cols="12">
          <p class="key-sub">Se restablecio la cuenta exitosamente</p>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mb-2">
        <button @click="finish()" class="key-aceptar">ACEPTAR</button>
      </b-row>
    </b-modal>
    <b-modal content-class="modal-finish" hide-footer ref="modal-delete" centered size="md">
      <b-row align-h="center" class="mt-5 examen-finish">
        <p class="mt-2" style="color:#0F376E">Eliminar Cuenta</p>
      </b-row>
      <b-row align-h="center" class="mt-4 examen-finish2">
        <p>Estas seguro que desea eliminar esta cuenta?</p>
      </b-row>
      <b-row align-h="center" class="mb-1 mt-4 ml-1">
        <b-col lg="6">
          <button
            @click="cancel()"
            style="color:#0F376E!important"
            class="modal-button-cancel"
          >CANCELAR</button>
        </b-col>
        <b-col lg="6">
          <button
            @click="accept()"
            style="background-color:#0F376E!important"
            class="modal-button-accept"
          >ACEPTAR</button>
        </b-col>
      </b-row>
    </b-modal>
  </b-container>
</template>
<script>
import moment from "moment";
export default {
  name: "SearchAccount",
  props: {
    accounts: {
      type: Array
    },
    GetAccounts: {
      type: Function
    }
  },
  data: () => ({
    perPage: 10,
    currentPage: 1,
    search: "",
    password: "",
    password2: "",
    show: true,
    show2: false,
    id: ""
  }),
  created() {},
  mounted() {},
  methods: {
    sendEmail(item) {
      let data = {
        email: item.email,
        id: item.password
      };
      console.log(data);
      this.$store.dispatch("sendCredentials", data).then(response => {
        if (response.data) {
          this.GetAccounts();
        }
      });
    },
    onChange(event, id) {
      let data = {
        id: id,
        status: event.target.checked
      };
      console.log(data);
      this.$store.dispatch("updateAccount", data).then(response => {
        if (response.data) {
          this.GetAccounts();
        }
      });
    },
    irReporte(value) {
      console.log(value);
      this.$store.dispatch("setSearch", value.key);
      this.$router.push("reportes");
    },
    cancel() {
      this.$refs["modal-delete"].hide();
    },
    accept() {
      let data = {
        id: this.id
      };
      this.$store.dispatch("deleteAccount", data).then(response => {
        if (response.data) {
          this.GetAccounts();
          this.$refs["modal-delete"].hide();
        }
      });
    },

    calcel() {
      this.$refs["modal-delete"].hide();
    },
    eliminar(id) {
      this.id = id;
      this.$refs["modal-delete"].show();
    },
    finish() {
      this.$refs["modal-password2"].hide();
    },
    ResPassword() {
      let data = {
        id: this.id,
        password: this.password
      };
      if (this.password == this.password2) {
        this.$store.dispatch("updateAPassword", data).then(response => {
          if (response.data) {
            this.$refs["modal-password"].hide();
            this.$refs["modal-password2"].show();
            this.password = "";
            this.password2 = "";
            this.GetAccounts();
          }
        });
      } else {
        this.show = false;
        this.show2 = true;
      }
    },
    UpdatePassword(id) {
      this.id = id;
      console.log(this.id);
      this.$refs["modal-password"].show();
    }
  },
  computed: {
    list() {
      const items = this.accounts;
      return items.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    totalRows() {
      return this.accounts.length;
    },
    isAdmin() {
      return this.$store.getters["isAdmin"];
    }
  },
  filters: {
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    rol(value) {
      var valor = " ";
      switch (value) {
        case 1:
          valor = "Administrador";
          break;
        case 2:
          valor = "Asesor";
          break;
        case 3:
          valor = "Colegio";
          break;
      }
      return valor;
    }
  }
};
</script>